import { render, staticRenderFns } from "./CSVOptions.vue?vue&type=template&id=48950661&scoped=true&"
import script from "./CSVOptions.vue?vue&type=script&lang=js&"
export * from "./CSVOptions.vue?vue&type=script&lang=js&"
import style0 from "./CSVOptions.vue?vue&type=style&index=0&id=48950661&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48950661",
  null
  
)

export default component.exports